export default __webpack_public_path__ + "static/Holztransport LKW-09ae285c4d6a823a20574273ced3b008.jpg";